import React, { useEffect, useRef } from 'react';

// Components
import { useFormik } from 'formik';
import * as S from '../Styled';
import InputMask from 'react-input-mask';
import Input from '../../../Input';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button } from '../../../Button';

// Store
import { useSelector } from 'react-redux';

// Utils
import cn from 'classnames';
import i18next from 'i18next';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

const Form = ({ googleReCaptchaProps, onOk }) => {
  const { vErrors, isLoading, data, forgotData } = useSelector(
    state => state.auth
  );
  const passwordRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (vErrors) {
      vErrors.map(i => formik.setFieldError(i.field, i.error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vErrors]);

  useEffect(() => {
    if (passwordRef.current) {
      passwordRef.current.focus();
    }
  }, []);

  useEffect(() => {
    formik.setFieldValue('token', data?.token);
    formik.setFieldValue('phone', data?.phone);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (forgotData !== null) {
      formik.setFieldValue('token', forgotData?.token);
      formik.setFieldValue('phone', forgotData?.phone);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotData]);

  const onSubmit = async values => {
    let token = await googleReCaptchaProps.executeRecaptcha('reset');
    let payload = {
      phone: values.phone,
      password: values.password,
      password_confirmation: values.password_confirmation,
      confirmation_code: values.confirmation_code,
      token: values.token,
      _recaptcha: token,
    };

    await onOk(payload);
  };

  const formik = useFormik({
    initialValues: {
      phone: '',
      password: '',
      password_confirmation: '',
      confirmation_code: '',
      token: '',
    },
    validationSchema: Yup.object({
      password: Yup.string().required(i18next.t('validation.required')),
      password_confirmation: Yup.string().oneOf(
        [Yup.ref('password'), null],
        t('validation.passwords_dont_match')
      ),
    }),
    onSubmit: async values => await onSubmit(values),
  });
  const { errors, handleSubmit, handleChange, touched } = formik;

  return (
    <form onSubmit={handleSubmit}>
      <S.Container>
        <S.Title>{t('labels.password_recovery')}</S.Title>
        <S.Row
          className={cn({
            error: errors.password,
          })}
        >
          <Input
            label={t('labels.password')}
            name="password"
            type="password"
            onChange={handleChange}
            ref={passwordRef}
          />
          <S.Error>{touched.password && errors.password}</S.Error>
        </S.Row>
        <S.Row
          className={cn({
            error: errors.password_confirmation,
          })}
        >
          <Input
            label={t('labels.repeat_password')}
            name="password_confirmation"
            type="password"
            onChange={handleChange}
          />
          <S.Error>
            {touched.password_confirmation && errors.password_confirmation}
          </S.Error>
        </S.Row>
        {data?.sms ? (
          <S.Row
            className={cn({
              error: errors.confirmation_code,
            })}
          >
            <InputMask
              name="confirmation_code"
              type="text"
              onChange={handleChange}
              mask="99-99-99"
              maskPlaceholder={null}
            >
              <Input label="Пароль из смс" />
            </InputMask>
            <S.Error>
              {touched.confirmation_code && errors.confirmation_code}
            </S.Error>
          </S.Row>
        ) : null}
        <S.Row>
          <Button
            size="middle"
            type="primary"
            htmlType="submit"
            disabled={isLoading}
          >
            {t('buttons.send')}
          </Button>
        </S.Row>
      </S.Container>
    </form>
  );
};

export default withGoogleReCaptcha(Form);
